module.exports = __webpack_public_path__ + "static/media/download-icon.3b7c393a.svg";